import React from 'react';
import PropTypes from 'prop-types';
import { createRoot } from 'react-dom/client';
import { LegacyColors } from 'constants';

const styles = {
  width: '100%',
  background: LegacyColors.errorBackground,
  color: LegacyColors.error,
  textAlign: 'center',
  position: 'fixed',
  padding: 5,
  zIndex: 9999,
  top: 0,
  left: 0,
};

const Alert = ({ children, style }) => (
  <div className="alf-alert" style={{ ...styles, ...style }}>
    {children}
  </div>
);

export const showErrorAlert = (props) => {
  const { duration, message, description } = props;
  const div = document.createElement('div');
  document.body.appendChild(div);
  const root = createRoot(div);
  root.render(
    <Alert>
      <strong>{message}</strong>
      {` ${description}`}
    </Alert>,
  );
  setTimeout(() => {
    div.parentNode.removeChild(div);
  }, duration || 5000);
  window.scrollTo(0, 0);
  return null;
};

Alert.propTypes = {
  children: PropTypes.any,
  style: PropTypes.object,
};

export default Alert;
